// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".div-inclui {\n  height: 55px;\n}\n.div-inclui button {\n  height: 30px;\n  position: absolute;\n  padding-top: 0px;\n}\n\n/* On small screens */\n@media (max-width: 767px) {\n  .div-inclui button {\n    top: 0;\n  }\n}\n/* On large screens */\n@media (min-width: 768px) {\n  .div-inclui button {\n    bottom: 0;\n  }\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
